module.exports = __webpack_public_path__ + "player.90f7b24a.png";